.fp-card
  .fp-vertical-spacing.-s-sm.-h100
    .fp-vertical-spacing--line.-justify-center.-expand
      .fp-image.-fluid
        FairplayerImageVue(:url='club.logoUrl' :resolution='ImageResolution.SM' contain)
    .fp-vertical-spacing--line.-align-center
      .fp-text.-text-lg.-text-semi-bold(data-test='platform-name') {{ club.platformName }}
